/* tslint:disable:no-small-switch */
import { BpPlacementComponentConstructor } from '../../models/component.model';
import { BaseTextPlacementComponent } from '../../components/base-text-placement/base-text-placement.component';
export const SSRTextPlacementContentType = 'SSRTextPlacementContent';
export function lookupPlacementConstructor(componentType: string): BpPlacementComponentConstructor<BaseTextPlacementComponent> {
  switch (componentType) {
    case SSRTextPlacementContentType:
      return BaseTextPlacementComponent;
  }
}
